import React, { FC, useMemo } from 'react';
import cn from 'classnames';

import { defaultFontSize, defaultFontWeight, defaultLineHeight, defaultTheme } from './config';
import { calcHeight, getLineHeight, prepareSet, getTheme } from './helpers';
import { IFontPreset, TProps } from './models';

export const Text: FC<TProps> = ({
    Tag = 'p',
    // todo: на следюущей итерации добавить дефолтное значение из пропа Tag
    tag,
    dataTestId = 'text',
    children,
    className,
    decoration,
    fontSize = defaultFontSize,
    showDataNosnippet,
    fontWeight,
    kind,
    lineHeight,
    lines,
    noClasses,
    styles,
    fontPreset,
    theme = defaultTheme,
    textTransform,
    view,
}) => {
    const set: IFontPreset = prepareSet({
        fontPreset,
        view,
        textTransform,
        lineHeight,
        fontWeight,
        fontSize,
    });

    // Выбираем самое подходящее число из указанного в line-height, на случай если пользователи указали несуществующий line-height
    const lineHeightPx = set.lineHeight ? getLineHeight(set.lineHeight) : defaultLineHeight;

    const textTheme = useMemo(() => getTheme(theme), [theme]);

    // eslint-disable-next-line external-classname/specificity
    const classNames = noClasses
        ? className
        : cn(
              styles.text,
              {
                  [styles[`${textTheme}Theme`]]:
                      // Так-то тема нам не нужна, но kind без неё не всегда работает
                      textTheme !== defaultTheme || kind,
                  [styles[`fontSize${set.fontSize}`]]: set.fontSize !== defaultFontSize,
                  [styles[`fontWeight${set.fontWeight}`]]:
                      set.fontWeight && set.fontWeight !== defaultFontWeight,
                  [styles[`lineHeight${lineHeightPx}`]]: lineHeightPx !== defaultLineHeight,
                  [styles[`${kind}Kind`]]: kind,
                  [styles[`letterSpacing${set.letterSpacing}`]]: set.letterSpacing,
                  [styles[`${decoration}Decoration`]]: decoration,
                  [styles[`${set.textTransform}TextTransform`]]: set.textTransform,
              },
              className
          );

    const height = calcHeight(lines, lineHeightPx, set.fontSize);
    const TagElement = tag || Tag;

    return (
        <TagElement
            className={classNames}
            data-nosnippet={showDataNosnippet ? true : undefined}
            data-test-id={dataTestId}
            style={{ height }}
        >
            {children}
        </TagElement>
    );
};
